import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';
import { CreateAvatarProjectInput } from '../../../types/avatar-video';

export const useCreateAvatarProject = () => {
  const { callEndpoint } = useAPIContext();

  const createAvatarProject = React.useCallback(
    async (payload: CreateAvatarProjectInput) => {
      try {
        const res = await callEndpoint<AvatarsAPI, 'create-avatar-project'>('avatars', '/project', 'POST', payload);
        if (!res) throw new Error('Respuesta del servidor inesperada');
        return res;
      } catch (error: any) {
        console.error('Error al crear proyecto:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { createAvatarProject };
};
